//项目详情基本信息
import BASE_API from '@/api/dataBase';

export const tableColumns = (ctx) => {
  return [
    {
      prop: 'createDepartmentName',
      name: '创建组织',
      type: 'input',
      // type: 'treeSelect',
      // apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
      // isName: true, // 是否返回名字
      // multiple: false,
      placeholder: '自动填写',
      // currentValue: ctx.baseInfoData.createDepartmentNo, // 默认选中的
      // returnType: 'object',
      // apiData: {
      //   tenantCode: ctx.userInfo.tenantCode,
      //   adminFlag: ctx.userInfo.adminFlag,
      //   // selfCompanyDepartmentTreeFlag: true,
      // },
      disabled: true,
      // fixme
    },
    {
      name: '项目来源',
      prop: 'projectSourceType',
      type: 'select',
      options: [
        { value: 'SWQT', label: '商务洽谈' },
        { value: 'TB', label: '投标' },
        { value: 'OT', label: '其他' },
      ],
      changeMethod: 'changeMethod',
    },
    // {
    //   prop: 'saleDepartmentName',
    //   name: '销售组织',
    //   type: 'treeSelect',
    //   apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
    //   isName: true, // 是否返回名字
    //   multiple: false,
    //   currentValue: ctx.baseInfoData.saleDepartmentNo, // 默认选中的
    //   returnType: 'object',
    //   // currentValue: '7024', // 默认选中的
    //   apiData: {
    //     tenantCode: ctx.userInfo.tenantCode,
    //     adminFlag: ctx.userInfo.adminFlag,
    //   },
    //   // fixme
    // },
    {
      name: '投标抬头',
      prop: 'bidTitle',
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'INTERMODALITY-SIGN-TITLE' },
      valueKey: 'label',
      labelKey: 'label',
      currentValue: ctx.baseInfoData.bidTitle,
      isHidden: ctx.baseInfoData.projectSourceType == 'SWQT',
    },
    {
      name: '投标人员',
      prop: 'bidderId',
      type: 'searchTableSpec',
      isMultiple: true,
      currentValue: ctx.baseInfoData.bidderName,
      changeMethod: 'changeMethod',
      searchType: 'personnel',
      isHidden: ctx.baseInfoData.projectSourceType == 'SWQT',
      // fixme
    },
    {
      name: '项目名称',
      prop: 'projectName',
      type: 'input',
    },
    {
      name: '项目编号',
      prop: 'projectCode',
      type: 'input',
      placeholder: '自动生成',
      disabled: true,
      // fixme
    },
    {
      name: '投标总金额',
      prop: 'bidTotalAmount',
      type: 'inputNumber',
      max: 9999999999,
      isHidden: ctx.baseInfoData.projectSourceType == 'SWQT',
      precision: 6,
    },
    {
      name: '立项申请日期',
      prop: 'applyDate',
      type: 'date',
      changeMethod: 'changeMethod',
    },
    {
      name: '开标日期',
      prop: 'bidOpeningDate',
      type: 'date',
      changeMethod: 'changeMethod',
      isHidden: ctx.baseInfoData.projectSourceType == 'SWQT',
    },
    {
      name: '截标日期',
      prop: 'bidClosingDate',
      type: 'date',
      changeMethod: 'changeMethod',
      isHidden: ctx.baseInfoData.projectSourceType == 'SWQT',
    },
    //     async getCompany() {
    //   // 公司
    //   let res = await this.$baseRequest.getCompanyList();
    //   if (res) {
    //     this.companyOptions = res;
    //   }
    // },
    // {
    //   //fixme
    //   name: '联动单位',
    //   prop: 'linkedCompanyCode',
    //   type: 'ajaxSelect',
    //   apiUrl: BASE_API.LISTDATA_SERECHCOMPANY + `/${ctx.userInfo.tenantCode}`,
    //   method: 'get',
    //   valueType: 'object',
    //   currentValue: ctx.baseInfoData.linkedCompanyName,
    //   changeMethod: 'changeMethod',
    //   // fixme
    // },
    {
      name: '联动单位',
      prop: 'linkedCompanyCode',
      type: 'searchTableSpec',
      searchType: 'linkedCompany',
      currentValue: ctx.baseInfoData.linkedCompanyName,
      isMultiple: true,
      changeMethod: 'changeMethod',
      extraData: {
        tenantCode: '1',
      },
      // options:[{value:'1111',label:'111'},{value:'1112',label:'112'}],
    },
    {
      name: '项目业务类型', //
      prop: 'projectBusinessTypeNo',
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'mto_business_type' },
      changeMethod: 'changeMethod',
      currentValue: ctx.baseInfoData.projectBusinessTypeNo,
    },

    {
      name: '',
      prop: '',
      span: 24,
    },
    {
      name: '',
      prop: '',
      span: 24,
    },
    {
      name: '项目开始日期',
      prop: 'projectStartDate',
      changeMethod: 'changeMethod',
      type: 'date',
    },
    {
      name: '项目结束日期',
      prop: 'projectEndDate',
      changeMethod: 'changeMethod',
      type: 'date',
    },
    {
      name: '项目盈利模式',
      prop: 'projectProfitModel',
      maxlength: 500,
      type: 'input',
    },
    {
      name: '项目盈利说明',
      prop: 'projectProfitDescription',
      maxlength: 500,
      type: 'input',
    },
    {
      name: '项目风险点',
      prop: 'projectRiskPoints',
      maxlength: 500,
      type: 'input',
    },
    {
      name: '风险防范措施',
      prop: 'riskPreventionMeasures',
      maxlength: 500,
      type: 'input',
    },
    {
      name: '项目整体描述',
      prop: 'projectOverallDescription',
      maxlength: 500,
      type: 'input',
    },
    {
      name: '创建人',
      prop: 'createByName',
      visible: ctx.pageMode != 0,
      disabled: true,
      type: 'input',
      //默认创建时系统登陆人姓名，不可编辑  fixme
    },
    {
      name: '创建时间',
      prop: 'gmtCreate',
      visible: ctx.pageMode != 0,
      disabled: true,
      type: 'date',
    },
    {
      name: '更新人',
      prop: 'lastModifiedByName',
      visible: ctx.pageMode != 0,
      disabled: true,
      type: 'input',
      // fixme   默认最后一次修改时系统登陆人姓名
    },
    {
      name: '更新时间',
      prop: 'gmtModified',
      visible: ctx.pageMode != 0,
      disabled: true,
      type: 'date',
    },
    {
      name: '项目状态',
      prop: 'projectStatus',
      visible: ctx.pageMode != 0,
      placeholder: '自动填写',
      type: 'ajaxSelect',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'INTERMODALITY-PROJECT-STATUS' },
      disabled: true,
      //fixme  项目当前所处状态，系统自动更新
    },
    {
      name: '',
      prop: '',
      span: 24,
    },
    {
      name: '',
      prop: '',
      span: 24,
    },
    {
      prop: 'platformCompanyName',
      name: '平台公司',
      type: 'ajaxSelect',
      placeholder: '请选择平台公司',
      apiUrl: BASE_API.DIC_CREDIT_API,
      apiData: { dictType: 'INTERMODALITY-PLATFORM-COMPANY' },
      currentValue: ctx.baseInfoData.platformCompanyName,
      valueKey: 'label',
      labelKey: 'label',
      changeMethod: 'changeMethod',
      multiple: true,
    },
    {
      prop: 'businessCycle',
      name: '业务周期',
      type: 'inputNumber',
      max: 99999999999,
      precision: 0,
      append: '月',
      placeholder: '请填写业务周期',
    },
    {
      prop: 'collectionDays',
      name: '回款期限',
      type: 'inputNumber',
      max: 99999999999,
      precision: 0,
      append: '月',
      placeholder: '请填写回款期限',
    },
    {
      prop: 'isBidBusiness',
      name: '是否为中标业务',
      type: 'select',
      options: [
        { value: '1', label: '是' },
        { value: '0', label: '否' },
      ],
      placeholder: '请选择',
    },
    {
      prop: 'estimatedProfit',
      name: '预估利润',
      type: 'inputNumber',
      max: 9999999999,
      precision: 6,
      placeholder: '请填写预估利润',
      append: '元',
    },
    {
      prop: 'projectSort',
      name: '项目分类',
      type: 'select',
      options: [
        { value: 'sp', label: '中小项目' },
        { value: 'bp', label: '重大项目' },
      ],
      placeholder: '请选择项目分类',
    },
  ];
};
